import { IconButton } from "@mui/material";
import clsx from "clsx";
import dialogStyles from "../dialogStyles.module.css";

interface Props {
  title?: string;
  visible?: boolean;
  disabled?: boolean;
  onClick?: (ev?: any) => void;
  icon?: React.JSX.Element;
}

export default function DialogHeaderButton(props: Props) {
  const { icon, onClick, visible, disabled, title } = props;
  return (
    <IconButton
      className={clsx(dialogStyles.dialogHeaderButton, !visible && dialogStyles.dialogHidden)}
      disabled={disabled}
      onClick={onClick}
      title={title}
    >
      {icon || null}
    </IconButton>
  );
}
